// 所有模块的请求
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { get } from 'lodash'

//const url = 'https://oa.yunqingtech.com:443';
//http://14.29.237.113:8088   正式环境  用车管理模块才用
const url = store.state.IPAss.TP; // 本机测试 意义不大
// 创建axios实例
const service = axios.create({
  baseURL: url, // url = base url + request url
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  timeout: 120000,// request timeout
  // 防止后端返回的 Long 类型（雪花算法等 19 位 ID）在 JSON.parse 时丢失精度
  transformResponse: [function (data) {
    if (typeof data !== 'string') return data
    try {
      const safe = data.replace(/"(\d{16,})"\s*:/g, '"$1":').replace(/:\s*(\d{16,})(?=[,\s}\]])/g, ':"$1"')
      return JSON.parse(safe)
    } catch (e) {
      return data
    }
  }],
})


// request拦截器
service.interceptors.request.use(
  config => {
    //如果存在token，请求携带这个token
    if (window.sessionStorage.getItem('userIdStr')) {
      config.headers['userIdStr'] = window.sessionStorage.getItem('userIdStr');
    }
    // config.headers['Priority-value'] = 'xm';
    return config;

  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * 如果您想获得http信息，如标头或状态
   * 请返回response => response
  */
  response => {
    // 判断是否为文件流响应（显式要求 blob 的请求直接返回流，覆盖 docx/xlsx 等所有附件类型）
    const contentType = response.headers['content-type'];
    if (response.config.responseType === 'blob' ||
      (contentType && (contentType.includes('application/octet-stream') ||
        contentType.includes('application/pdf') ||
        contentType.includes('image/jpeg')))) {
      return response.data; // 返回文件流数据
    }

    const res = response.data;

    if (res.code !== 200) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
      if (res.code === 500 || res.code === 512 || res.code === 504 || res.code === 401 || res.code === 201) {
        // 可根据具体情况添加处理逻辑
      }
      return res || 'Error';
    } else {
      return res;
    }
  },
  error => {
    return error.response?.data;
  }
);

export default service

